import React from 'react';
import Hero from '../components/sections/Hero';
import About from '../components/sections/About';
import Services from '../components/sections/Services';
import Portfolio from '../components/sections/Portfolio';
import Contact from '../components/sections/Contact';
import Footer from '../components/sections/Footer';

const Home = () => {
    return (
        <div className="min-h-screen bg-white">
            <Hero />
            <About />
            <Services />
            <Portfolio />
            <Contact />
            <Footer />
        </div>
    );
};

export default Home;
